import LazyContent, { lazyModule } from "./LazyContent";

export default LazyContent;
export { lazyModule };
